import React from 'react';
import ReactDOM from 'react-dom';
import * as PropType from '../common/propType';
import './index.less';

const MODAL_ROOT_ID = 'dialog';

export interface ModalPropType extends PropType.StylePropType {
    prefixCls?: string;
    mask?: boolean;
    maskStyle?: any;
    onClick?: any;
    onClose?: any
}

/**
 * 弹层包裹组件
 * @class Modal
 * @extends {React.Component<ModalPropType>}
 */
class Modal extends React.Component<ModalPropType> {
    static defaultProps = {
        prefixCls: 'modal',
        mask: true,
    };

    modal: HTMLElement;

    componentWillMount() {
        let root = document.getElementById(MODAL_ROOT_ID);
        if (!root) {
            root = document.createElement('div');
            document.body.appendChild(this.modal);
            root.id = MODAL_ROOT_ID;
        }
        this.modal = root;
    }

    render() {
        const {prefixCls, maskStyle, onClose, mask, children} = this.props;
        return ReactDOM.createPortal(
            <div className={prefixCls}>
                {
                    mask && (
                        <div className={`${prefixCls}-mask`} style={maskStyle}/>
                    )
                }
                <div className={`${prefixCls}-wrapper`} onClick={(e) => {
                    if (onClose && e.target['className'] == `${prefixCls}-wrapper`) onClose();
                }}>
                    {children}
                </div>
            </div>
            , this.modal
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/modal/index.tsx